export class ChipOverflowObserver {
    ro: ResizeObserver | null;
    mo: MutationObserver | null;
    onWindowResize: (() => void) | null;
    onMediaChange: (() => void) | null;
    mediaQuery: MediaQueryList | null;
    element: Element | null;
    context: any | null;

    constructor() {
        this.ro = null;
        this.mo = null;
        this.onWindowResize = null;
        this.onMediaChange = null;
        this.mediaQuery = null;
        this.element = null;
        this.context = null;
    }

    observe(element: Element, context: any) {
        this.dispose();

        this.element = element;
        this.context = context;

        const check = () => {
            if (!this.element || !this.context) return;

            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            const hasOverflow = this.element.scrollHeight > this.element.clientHeight + 1;

            this.context.OnOverflowChanged.callee
                .invokeMethodAsync(this.context.OnOverflowChanged.function, hasOverflow, isMobile)
                .catch((e: any) => console.error(e));
        };

        this.ro = new ResizeObserver(check);
        this.ro.observe(element);

        this.mo = new MutationObserver(check);
        this.mo.observe(element, { childList: true, subtree: true, characterData: true });

        this.onWindowResize = check;
        window.addEventListener('resize', this.onWindowResize);

        this.mediaQuery = window.matchMedia('(max-width: 767px)');
        this.onMediaChange = check;
        this.mediaQuery.addEventListener('change', this.onMediaChange);

        requestAnimationFrame(check);
        setTimeout(check, 0);
        setTimeout(check, 100);
    }

    dispose() {
        if (this.ro) {
            this.ro.disconnect();
            this.ro = null;
        }

        if (this.mo) {
            this.mo.disconnect();
            this.mo = null;
        }

        if (this.onWindowResize) {
            window.removeEventListener('resize', this.onWindowResize);
            this.onWindowResize = null;
        }

        if (this.mediaQuery && this.onMediaChange) {
            this.mediaQuery.removeEventListener('change', this.onMediaChange);
            this.onMediaChange = null;
            this.mediaQuery = null;
        }

        this.element = null;
        this.context = null;
    }
}